const theme = {
  global: {}
};

export default theme;
